/* Procycles Parts Finder - core (v2)
   Loaded once per page by snippets/pcf-core.liquid. Every finder widget talks to window.PCF.
   Data: assets/pcf-bikes.json  { v, makes:[{h,n}], bikes:[[handle, make, model, year, yearTo]] }
   Storage: localStorage pcf_active / pcf_garage (shape below). Customer sync via window.PCF_CUSTOMER.
   Bike object: { handle, tag, year, make, makeName, model, name }
*/
(function () {
  'use strict';
  if (window.PCF) return;

  var cfg = window.PCF_CONFIG || {};
  var ACTIVE_KEY = 'pcf_active';
  var GARAGE_KEY = 'pcf_garage';
  var DATA_PREFIX = 'pcf_data:';
  var MAX_GARAGE = cfg.maxGarage || 5;

  var state = {
    ready: false, readyCbs: [], loadError: false,
    makes: {}, makeOrder: [], entries: [], byHandle: {},
    years: [], index: {},           // year -> make -> modelName -> [entries]
    active: null, garage: [], syncTimer: null
  };

  /* ---------- utils ---------- */
  function normalize(s) {
    return String(s == null ? '' : s).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function store(key, val) { try { if (val == null) localStorage.removeItem(key); else localStorage.setItem(key, JSON.stringify(val)); } catch (e) {} }
  function load(key) { try { return JSON.parse(localStorage.getItem(key)); } catch (e) { return null; } }
  function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} })); }
  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function bikeName(year, makeName, model) { return year + ' ' + makeName + ' ' + model; }

  /* ---------- data ---------- */
  function buildIndex(data) {
    state.makes = {}; state.makeOrder = []; state.entries = []; state.byHandle = {}; state.index = {};
    (data.makes || []).forEach(function (m) { state.makes[m.h] = m.n; state.makeOrder.push(m.h); });
    var yearSet = {};
    (data.bikes || []).forEach(function (row) {
      var e = { handle: row[0], make: row[1], makeName: state.makes[row[1]] || row[1], model: row[2], year: row[3], yearTo: row[4] || 0 };
      e.name = (e.yearTo ? e.year + '-' + e.yearTo : e.year) + ' ' + e.makeName + ' ' + e.model;
      state.entries.push(e); state.byHandle[e.handle] = e;
      var last = e.yearTo || e.year;
      for (var y = e.year; y <= last; y++) {
        yearSet[y] = true;
        var byMake = state.index[y] || (state.index[y] = {});
        var byModel = byMake[e.make] || (byMake[e.make] = {});
        (byModel[e.model] || (byModel[e.model] = [])).push(e);
      }
    });
    state.years = Object.keys(yearSet).map(Number).sort(function (a, b) { return b - a; });
  }

  function loadData() {
    var url = cfg.dataUrl;
    if (!url) { state.loadError = true; return; }
    var cacheKey = DATA_PREFIX + url;
    var cached = load(cacheKey);
    if (cached && cached.v === 2 && cached.bikes) { finishLoad(cached); return; }
    fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) {
        try { Object.keys(localStorage).forEach(function (k) { if (k.indexOf(DATA_PREFIX) === 0) localStorage.removeItem(k); }); } catch (e) {}
        store(cacheKey, data);
        finishLoad(data);
      })
      .catch(function () { state.loadError = true; emit('pcf:load-error'); });
  }

  function finishLoad(data) {
    buildIndex(data);
    hydrate();
    state.ready = true;
    state.readyCbs.splice(0).forEach(function (cb) { try { cb(PCF); } catch (e) { console.error(e); } });
    emit('pcf:ready');
    syncFromCustomer();
  }

  /* ---------- lookups ---------- */
  function resolve(year, make, model) {
    year = parseInt(year, 10); make = normalize(make);
    var byMake = state.index[year]; if (!byMake) return null;
    var byModel = byMake[make]; if (!byModel) return null;
    var list = byModel[model]; if (!list || !list.length) return null;
    var single = null;
    for (var i = 0; i < list.length; i++) if (!list[i].yearTo && list[i].year === year) { single = list[i]; break; }
    var makeName = list[0].makeName;
    var tag = single ? single.handle : normalize(year + ' ' + make + ' ' + model);
    return { handle: single ? single.handle : tag, tag: tag, year: year, make: make, makeName: makeName, model: model, name: bikeName(year, makeName, model) };
  }
  function fromHandle(handle) {
    var e = state.byHandle[handle];
    if (!e || e.yearTo) return null;
    return resolve(e.year, e.make, e.model);
  }
  function makesFor(year) {
    var byMake = state.index[parseInt(year, 10)] || {};
    return state.makeOrder.filter(function (m) { return byMake[m]; }).map(function (m) { return { handle: m, name: state.makes[m] }; });
  }
  function modelsFor(year, make) {
    var byMake = state.index[parseInt(year, 10)] || {};
    var byModel = byMake[normalize(make)] || {};
    return Object.keys(byModel).sort(function (a, b) { return a.localeCompare(b, undefined, { numeric: true }); });
  }

  /* ---------- active bike + garage ---------- */
  function normalizeStored(b) {
    if (!b || typeof b !== 'object') return null;
    if (b.tag && b.handle && b.name) return b;
    if (b.year && b.make && b.model) return resolve(b.year, b.make, b.model);   // legacy v1 shape
    return null;
  }
  function hydrate() {
    state.active = normalizeStored(load(ACTIVE_KEY));
    var g = load(GARAGE_KEY);
    state.garage = Array.isArray(g) ? g.map(normalizeStored).filter(Boolean) : [];
    dedupeGarage();
    store(ACTIVE_KEY, state.active); store(GARAGE_KEY, state.garage);
  }
  function dedupeGarage() {
    var seen = {}, out = [];
    state.garage.forEach(function (b) { if (b && !seen[b.handle]) { seen[b.handle] = true; out.push(b); } });
    state.garage = out.slice(0, MAX_GARAGE);
  }
  function setActive(bike, opts) {
    if (!bike) return clearActive();
    state.active = bike; store(ACTIVE_KEY, bike);
    emit('pcf:active-changed', bike);
    if (!(opts && opts.silent)) scheduleSync();
    return bike;
  }
  function clearActive() {
    state.active = null; store(ACTIVE_KEY, null);
    emit('pcf:cleared'); scheduleSync();
  }
  function garageSave(bike) {
    if (!bike) return 'invalid';
    if (state.garage.some(function (b) { return b.handle === bike.handle; })) return 'duplicate';
    if (state.garage.length >= MAX_GARAGE) return 'full';
    state.garage.push(bike); store(GARAGE_KEY, state.garage);
    emit('pcf:garage-changed', { garage: state.garage }); scheduleSync();
    return 'ok';
  }
  function garageRemove(handle) {
    state.garage = state.garage.filter(function (b) { return b.handle !== handle; });
    store(GARAGE_KEY, state.garage);
    emit('pcf:garage-changed', { garage: state.garage }); scheduleSync();
  }
  function garageClear() {
    state.garage = []; store(GARAGE_KEY, state.garage);
    emit('pcf:garage-changed', { garage: state.garage }); scheduleSync();
  }
  function isSaved(handle) { return state.garage.some(function (b) { return b.handle === handle; }); }

  /* ---------- customer sync ---------- */
  function customer() { return window.PCF_CUSTOMER && window.PCF_CUSTOMER.id ? window.PCF_CUSTOMER : null; }
  function syncFromCustomer() {
    var c = customer(); if (!c) return;
    var profile = Array.isArray(c.garage) ? c.garage.map(fromHandle).filter(Boolean) : [];
    var merged = profile.slice();
    state.garage.forEach(function (b) { if (!merged.some(function (p) { return p.handle === b.handle; })) merged.push(b); });
    merged = merged.slice(0, MAX_GARAGE);
    var changed = merged.length !== profile.length;
    state.garage = merged; store(GARAGE_KEY, state.garage);
    if (!state.active && c.active) { var a = fromHandle(c.active); if (a) { state.active = a; store(ACTIVE_KEY, a); emit('pcf:active-changed', a); } }
    else if (state.active && state.active.handle !== c.active) changed = true;
    emit('pcf:garage-changed', { garage: state.garage });
    if (changed) scheduleSync();
  }
  function scheduleSync() {
    var c = customer(); if (!c || !cfg.garageEndpoint) return;
    clearTimeout(state.syncTimer);
    state.syncTimer = setTimeout(pushToCustomer, 600);
  }
  function pushToCustomer() {
    var c = customer(); if (!c || !cfg.garageEndpoint) return;
    var body = JSON.stringify({ token: c.token, garage: state.garage.map(function (b) { return b.handle; }), active: state.active ? state.active.handle : null });
    try {
      fetch(cfg.garageEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true, credentials: 'omit' })
        .then(function (r) { emit('pcf:garage-synced', { ok: r.ok }); }).catch(function () { emit('pcf:garage-synced', { ok: false }); });
    } catch (e) {}
  }

  /* ---------- urls ---------- */
  function currentCollection() {
    var m = window.location.pathname.match(/^\/collections\/([^\/]+)/);
    return m ? m[1] : null;
  }
  /* No collection given -> the bike's own collection (small, so Shopify's sidebar filters keep working;
     the catch-all collection would lose them past 5,000 products). A collection given -> filter it by tag. */
  function partsUrl(bike, collectionHandle, keepParams) {
    var url = collectionHandle ? '/collections/' + collectionHandle + '/' + bike.tag : '/collections/' + bike.handle;
    if (keepParams) {
      var p = new URLSearchParams(window.location.search); p.delete('page');
      var qs = p.toString(); if (qs) url += '?' + qs;
    }
    return url;
  }
  function bikeCollectionUrl(bike) { return '/collections/' + bike.handle; }
  function loginUrl() {
    var back = window.location.pathname + window.location.search;
    return (cfg.loginUrl || '/account/login') + '?return_url=' + encodeURIComponent(back);
  }
  function go(url, bike, source) {
    emit('pcf:search', { bike: bike, url: url, source: source || '' });
    window.location.href = url;
  }

  /* ---------- fitment ---------- */
  function tagList(tags) { return Array.isArray(tags) ? tags : String(tags || '').split(','); }
  function fitsTags(tags, bike) {
    bike = bike || state.active; if (!bike) return null;
    var list = tagList(tags);
    for (var i = 0; i < list.length; i++) {
      var t = normalize(list[i]);
      if (t === bike.tag) return true;
      var e = state.byHandle[t];   // a range entry (from custom.fits_bikes) covers every year from year to yearTo
      if (e && e.yearTo && e.make === bike.make && e.model === bike.model && e.year <= bike.year && bike.year <= e.yearTo) return true;
    }
    return false;
  }
  function hasFitmentTags(tags) { return tagList(tags).some(function (t) { return /^(19|20)\d{2}-((19|20)\d{2}-)?[a-z]/.test(String(t).trim().toLowerCase()); }); }

  /* ---------- shared select controller ---------- */
  function fill(sel, placeholder, items, valueOf, labelOf) {
    sel.innerHTML = '';
    var o = document.createElement('option'); o.value = ''; o.textContent = placeholder; sel.appendChild(o);
    items.forEach(function (it) { var op = document.createElement('option'); op.value = valueOf(it); op.textContent = labelOf(it); sel.appendChild(op); });
  }
  /* Restrict the year/make/model index to entries whose handle is in `tags` (e.g. the fitment tags
     actually present on products in a collection), so a collection's finder can't offer bikes it has
     nothing for. No tags given -> unrestricted, same as before. */
  function scopedIndex(tags) {
    if (!tags) return { years: state.years, index: state.index };   // no tags arg at all -> unrestricted; an empty array means "restrict to nothing"
    var allowed = {}; tags.forEach(function (t) { allowed[t] = true; });
    var index = {}, yearSet = {};
    state.entries.forEach(function (e) {
      if (!allowed[e.handle]) return;
      var last = e.yearTo || e.year;
      for (var y = e.year; y <= last; y++) {
        yearSet[y] = true;
        var byMake = index[y] || (index[y] = {});
        var byModel = byMake[e.make] || (byMake[e.make] = {});
        (byModel[e.model] || (byModel[e.model] = [])).push(e);
      }
    });
    var years = Object.keys(yearSet).map(Number).sort(function (a, b) { return b - a; });
    return { years: years, index: index };
  }

  /* bindSelects({ year, make, model, onChange(bikeOrNull), placeholders:{year,make,model}, tags:[handle,...] }) */
  function bindSelects(o) {
    var ph = o.placeholders || {}; var pY = ph.year || 'Year', pM = ph.make || 'Make', pMo = ph.model || 'Model';
    var scoped = scopedIndex(o.tags);
    function scopedMakesFor(year) {
      var byMake = scoped.index[parseInt(year, 10)] || {};
      return state.makeOrder.filter(function (m) { return byMake[m]; }).map(function (m) { return { handle: m, name: state.makes[m] }; });
    }
    function scopedModelsFor(year, make) {
      var byMake = scoped.index[parseInt(year, 10)] || {};
      var byModel = byMake[normalize(make)] || {};
      return Object.keys(byModel).sort(function (a, b) { return a.localeCompare(b, undefined, { numeric: true }); });
    }
    var ctl = {
      value: function () { return o.model.value ? resolve(o.year.value, o.make.value, o.model.value) : null; },
      reset: function () { o.year.value = ''; fill(o.make, pM, [], null, null); fill(o.model, pMo, [], null, null); o.make.disabled = o.model.disabled = true; if (o.onChange) o.onChange(null); },
      set: function (bike) {
        if (!bike) return ctl.reset();
        o.year.value = bike.year; cascadeMake(); o.make.value = bike.make; cascadeModel(); o.model.value = bike.model;
        if (!o.model.value) return ctl.reset();
        if (o.onChange) o.onChange(ctl.value());
      }
    };
    function cascadeMake() {
      fill(o.make, pM, scopedMakesFor(o.year.value), function (m) { return m.handle; }, function (m) { return m.name; });
      fill(o.model, pMo, [], null, null);
      o.make.disabled = !o.year.value; o.model.disabled = true;
    }
    function cascadeModel() {
      fill(o.model, pMo, scopedModelsFor(o.year.value, o.make.value), function (m) { return m; }, function (m) { return m; });
      o.model.disabled = !o.make.value;
    }
    fill(o.year, pY, scoped.years, function (y) { return y; }, function (y) { return y; });
    fill(o.make, pM, [], null, null); fill(o.model, pMo, [], null, null);
    o.make.disabled = o.model.disabled = true;
    o.year.addEventListener('change', function () { cascadeMake(); if (o.onChange) o.onChange(null); });
    o.make.addEventListener('change', function () { cascadeModel(); if (o.onChange) o.onChange(null); });
    o.model.addEventListener('change', function () { if (o.onChange) o.onChange(ctl.value()); });
    return ctl;
  }

  /* ---------- public API ---------- */
  var PCF = window.PCF = {
    ready: function (cb) { if (state.ready) cb(PCF); else state.readyCbs.push(cb); },
    isReady: function () { return state.ready; },
    loadError: function () { return state.loadError; },
    years: function () { return state.years.slice(); },
    makes: makesFor, models: modelsFor, resolve: resolve, fromHandle: fromHandle,
    entry: function (h) { return state.byHandle[h] || null; },
    getActive: function () { return state.active; }, setActive: setActive, clearActive: clearActive,
    getGarage: function () { return state.garage.slice(); }, garageSave: garageSave, garageRemove: garageRemove, garageClear: garageClear, isSaved: isSaved,
    maxGarage: MAX_GARAGE,
    customer: customer, loginUrl: loginUrl,
    partsUrl: partsUrl, bikeCollectionUrl: bikeCollectionUrl, currentCollection: currentCollection, go: go,
    fitsTags: fitsTags, hasFitmentTags: hasFitmentTags,
    bindSelects: bindSelects, normalize: normalize, escapeHtml: escapeHtml
  };

  /* keep tabs in sync */
  window.addEventListener('storage', function (e) {
    if (e.key === ACTIVE_KEY || e.key === GARAGE_KEY) { hydrate(); emit(state.active ? 'pcf:active-changed' : 'pcf:cleared', state.active || {}); emit('pcf:garage-changed', { garage: state.garage }); }
  });

  loadData();
})();
